import { Layout, theme, Typography } from "antd";
import EmployeesTable from "../components/employees/EmployeesTable";
import AddEmployee from "../components/employees/AddEmployee";

const { Content } = Layout;
const Employees = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            YENİ ƏMƏKDAŞ
          </Typography.Title>
          <AddEmployee />
          <Typography.Title level={5} className="titles-start">
            ƏMƏKDAŞLAR
          </Typography.Title>
          <EmployeesTable />
        </div>
      </Content>
    </Layout>
  );
};

export default Employees;
